import { render, staticRenderFns } from "./cargoPortDischarging.vue?vue&type=template&id=c989082e"
import script from "./cargoPortDischarging.vue?vue&type=script&lang=js"
export * from "./cargoPortDischarging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports